import styled from "styled-components";

export const ViolationListContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export default ViolationListContainer;
